module.exports = __webpack_public_path__ + "img/judge.2a2d4866.png";